import { DefaultLoader } from '@euler/app/components/loaders/DefaultLoader';
import { Center } from '@euler/components/Center';
import { EmptyView } from '@euler/components/EmptyView';
import { memo } from 'react';
import { StyleProp, TextStyle, ViewStyle } from 'react-native';

export const EmptyListContent = memo(
  ({
    loading,
    error,
    emptyText = '暂无数据',
    style,
    onRetry,
    ...props
  }: {
    loading?: boolean;
    error?: Error;
    emptyText?: string;
    iconColor?: string;
    iconSize?: number;
    messageStyle?: StyleProp<TextStyle>;
    style?: StyleProp<ViewStyle>;
    onRetry?: () => void;
  }) => {
    if (loading) {
      return (
        <Center
          css={`
            flex: 1;
          `}
          style={style}
        >
          {/* Fix: DefaultLoader do not support css property */}
          <DefaultLoader
            style={{
              alignSelf: 'center',
            }}
          />
        </Center>
      );
    }
    return (
      <EmptyView
        message={
          error ? `加载数据失败 (${error?.message ?? '未知错误'})` : emptyText
        }
        onRetry={error ? onRetry : undefined}
        style={style}
        {...props}
        css={`
          align-self: center;
        `}
      />
    );
  },
);
